var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loadingDialog"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"download-div"},[_c('i',{staticClass:"el-icon-loading loadingClass"}),_c('span',{staticClass:"download-text"},[_vm._v(_vm._s(_vm.message))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }